import React from 'react';
import { useActivityTimer } from '../hooks/useActivityTimer';

/**
 * Component to display activity duration with real-time counter for running activities
 * @param {Object} activity - Activity object
 * @returns {JSX.Element} Duration display
 */
export const DurationCell = ({ activity }) => {
  const liveTime = useActivityTimer(activity.started_at, activity.is_running);

  if (activity.is_running) {
    return <span>{liveTime}</span>;
  }

  return <span>{activity.duration}</span>;
};
